import { fetcher } from '../utils'
import { KeycloakVO } from '@repo/types'

export default async (realm: string): Promise<KeycloakVO> => fetcher(`/api/public/keycloak/${realm}`, 'GET', undefined)
